import { makeStyles } from '@mui/styles';
import IconButton from 'apollo-react/components/IconButton';
import Peek from 'apollo-react/components/Peek';
import TreeItem from 'apollo-react/components/TreeItem';
import classNames from 'classnames';
import React, { useMemo, useState } from 'react';

import { getAlphabetDisableSet, getLabel } from './utils';
import { ALPHABET } from '../../../constants/Common';
import { useWindowDimensions } from '../../../custom-hooks/useWindowDimensions';

const useStyles = makeStyles({
  mobileItem: {
    '& div:nth-child(1)': {
      padding: '0 0',
    },
  },
  letter: {
    fontSize: '1.3rem',
  },
  selectedLetter: {
    color: '#f00',
  },
});

const RenderTreeItems = ({ node, type }) => {
  const { Children: nodeChildren, Id } = node;
  const showAlphabet = type === 'CDRH' && nodeChildren.length;
  const classes = useStyles();
  const { isMobileDevice } = useWindowDimensions();

  const [filterLetter, setFilterLetter] = useState(() =>
    showAlphabet ? nodeChildren[0].Name[0] : ''
  );

  const filteredNodeChildren = showAlphabet
    ? nodeChildren.filter(({ Name }) => Name.toUpperCase().startsWith(filterLetter))
    : nodeChildren;

  const disableSet = useMemo(() => getAlphabetDisableSet(nodeChildren), [nodeChildren]);

  return (
    <TreeItem
      nodeId={Id}
      className={isMobileDevice && classes.mobileItem}
      label={
        node.UDF4 ? (
          <Peek
            placement="bottom"
            anchor={<div>{getLabel(node, type)}</div>}
            content={<div style={{ maxWidth: 400 }}>{node.UDF4}</div>}
          />
        ) : (
          getLabel(node, type)
        )
      }
    >
      {filteredNodeChildren.map((child, index) => {
        const renderItem = <RenderMemoizedTreeItems key={index} node={child} type={type} />;

        return index === 0 && showAlphabet ? (
          <React.Fragment key={index}>
            {ALPHABET.map((letter) => (
              <IconButton
                key={letter}
                className={classNames({
                  [classes.letter]: true,
                  [classes.selectedLetter]: letter === filterLetter,
                })}
                disabled={!disableSet.has(letter)}
                onClick={() => setFilterLetter(letter)}
              >
                <span>{letter}</span>
              </IconButton>
            ))}
            {renderItem}
          </React.Fragment>
        ) : (
          renderItem
        );
      })}
    </TreeItem>
  );
};

const RenderMemoizedTreeItems = React.memo(RenderTreeItems);

export default RenderMemoizedTreeItems;
